<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { dateEnd, type DateRangeMode, dateStart } from '@/functions/fmt/date'

  const props = defineProps<{
    mode?: DateRangeMode,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const date1 = ref<Date | null>(dateStart(props.mode))
  const date2 = ref<Date | null>(dateEnd(props.mode))

  watch([date1, date2], ([newDate1, newDate2]) => {
    if (newDate1 && newDate2) {
      updateRoute({
        date_start: newDate1.toISOString(),
        date_end: newDate2.toISOString(),
      })
    } else {
      updateRoute({
        date_start: undefined,
        date_end: undefined,
      })
    }
  })

  watch(() => route.query.date_start, (newDateStart) => {
    if (newDateStart) {
      date1.value = new Date(newDateStart as string)
    } else {
      date1.value = dateStart(props.mode)
    }
  })
  watch(() => route.query.date_end, (newDateEnd) => {
    if (newDateEnd) {
      date2.value = new Date(newDateEnd as string)
    } else {
      date2.value = dateEnd(props.mode)
    }
  })
</script>

<template>
  <app-date-range-picker
    v-model:date1="date1"
    v-model:date2="date2" />
</template>
